import { SteadfastModel } from '@/http/models/courier/Steadfast'
import { toast } from 'sonner'

import { useState } from 'react'

export const useSteadfastCourier = () => {
  const [loading, setLoading] = useState(false)

  const createParcel = async (orderId: string) => {
    setLoading(true)
    try {
      const response = await SteadfastModel.createParcel({
        body: { order_id: orderId },
      })

      if (response.success) {
        toast.success('Steadfast parcel created successfully!')
        return response.data?.result
      } else {
        toast.error(response.error?.data?.message || 'Failed to create parcel')
        return null
      }
    } catch (error) {
      console.error('Steadfast parcel creation error:', error)
      toast.error('An error occurred while creating parcel')
      return null
    } finally {
      setLoading(false)
    }
  }

  const trackParcel = async (orderId: string) => {
    setLoading(true)
    try {
      const response = await SteadfastModel.trackParcel({
        body: { order_id: orderId },
      })

      if (response.success) {
        return response.data?.result
      } else {
        toast.error(response.error?.data?.message || 'Failed to track parcel')
        return null
      }
    } catch (error) {
      console.error('Steadfast tracking error:', error)
      return null
    } finally {
      setLoading(false)
    }
  }

  const cancelParcel = async (orderId: string) => {
    setLoading(true)
    try {
      const response = await SteadfastModel.cancelParcel({
        body: { order_id: orderId },
      })

      if (response.success) {
        toast.success('Steadfast parcel cancelled successfully!')
        return response.data?.result
      } else {
        toast.error(response.error?.data?.message || 'Failed to cancel parcel')
        return null
      }
    } catch (error) {
      console.error('Steadfast cancel error:', error)
      toast.error('An error occurred while cancelling parcel')
      return null
    } finally {
      setLoading(false)
    }
  }

  return {
    loading,
    createParcel,
    trackParcel,
    cancelParcel,
  }
}
